import settings from "@src/settings";

interface Props {
  rows: number;
  withBottomGap?: boolean;
  withTopGap?: boolean;
  fontSize?: number;
  lineGap?: number;
}

function getGridHeight({
  rows,
  withBottomGap=false,
  withTopGap=false,
  fontSize=settings.baseGrid.fontSize,
  lineGap=settings.baseGrid.lineGap
}: Props): number{
  return (fontSize + lineGap) * rows - (withBottomGap ? 0 : lineGap) + (withTopGap ? lineGap : 0)
}

export default getGridHeight;